module.exports = __webpack_public_path__ + "img/menkyo_back.416ea533.png";